import script from "./AdditionalLayers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdditionalLayers.vue?vue&type=script&setup=true&lang=js"

import "./AdditionalLayers.vue?vue&type=style&index=0&id=1583f174&lang=scss&scoped=true"

import exportComponent from "/builds/sovhoz/front-lk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1583f174"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QList from 'quasar/src/components/item/QList.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QList,QExpansionItem,QItem,QItemSection,QCheckbox,QRadio,QBtn});
